/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { router } from "@smakecloud/api-client-helper";
import { z } from "zod";
import { authedEndpoint } from "~/lib/api/builder";

const typeSchema = z.object({
    id: z.number(),
    name: z.string(),
});

const modelSchema = z.object({
    id: z.number(),
    name: z.string(),
    machine_type_id: z.number(),
    manufacturer_id: z.number(),
    positions: z.number().nullable(),
    production_type_id: z.number().nullable(),
    profile_jdf: z.unknown().nullable(),
    profile_xml: z.unknown().nullable(),
    protocol: z.string().nullable(),
    type: typeSchema,
});

const machineSchema = z.object({
    id: z.number(),
    name: z.string().nullable(),
    description: z.string().nullable(),
    external_identifier: z.string().nullable(),
    ip_address: z.string().nullable(),
    model: modelSchema,
});

const list = authedEndpoint.query(
    () => ({
        url: `machinery/machines`,
    }),
    {
        output: z.object({
            data: z.array(machineSchema),
            links: z.object({
                first: z.string().nullable(),
                last: z.string().nullable(),
                next: z.string().nullable(),
                prev: z.string().nullable(),
            }),
            meta: z.object({
                next_cursor: z.string().nullable(),
                path: z.string(),
                per_page: z.number(),
                prev_cursor: z.string().nullable(),
            }),
        }),
    },
);

const print = authedEndpoint.mutation(
    ({ id, bin_ids, dpi, rack_id }) => ({
        json: { bin_ids, dpi, rack_id },
        method: "post",
        url: `machinery/machines/${id}/print-presort-label`,
    }),
    {
        input: z.object({
            id: z.number(),
            bin_ids: z.array(z.number()).optional(),
            dpi: z.number(),
            rack_id: z.number().optional(),
        }),
        output: z.object({
            message: z.string(),
        }),
    },
);

export const machinery = router({
    list,
    print,
});
